import { render, staticRenderFns } from "./PromoCodeUsersList.vue?vue&type=template&id=23c38bbc&"
import script from "./PromoCodeUsersList.vue?vue&type=script&lang=js&"
export * from "./PromoCodeUsersList.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodeUsersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports